import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import axios from 'axios';

const BlogCardPage = () => {
  const location = useLocation();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/blogs/cards`);
        setCards(res.data);
      } catch (error) {
        console.error('Помилка завантаження карток:', error);
      }
    };
    fetchCards();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return { dayMonth: `${day}.${month}`, year };
  };

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <h1 className="blog_title">BLOG</h1>
        <div className="blog_card-container">
          {cards.map((card) => {
            const { dayMonth, year } = formatDate(card.createdAt);
            return (
              <div className="card_container" key={card._id}>
                <div className="image_card-container">
                  <img src={card.imageUrl} alt={card.title} />
                  <div className="data-card_item">
                    <p>{dayMonth}</p>
                    <span>{year}</span>
                  </div>
                </div>
                <div className="descr_card-container">
                  <div className="card_descr-text">
                    <p>{card.title}</p>
                    <span>{card.description}</span>
                  </div>
                  <Link to={`/blog-page/${card.blogId}`}>READ MORE</Link>
                </div>
              </div>
            );
          })}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default BlogCardPage;